import Layers from "slotworks/graphics/layers/layers";
import AbstractSliderControl from "slotworks/smart-ui/controls/abstract/abstract-slider-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { formatMoneyAsCurrency } from "slotworks/utils/string-formatters";

export default class CreditSizeSliderControl extends AbstractSliderControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.formatFunction = formatMoneyAsCurrency;

        this.sliderComponent.onChange.add(this.onChangeHandler);
        this.sliderComponent.onInput.add(this.onChangeHandler);
    }

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);

        this.setupData(options.creditSizes.values, options.creditSizes.currentValue || options.creditSizes.defaultValue);
    }

    protected onChangeHandler = (value: number) => {
        const options = new ControlOptions();
        options.creditSizes = this.options.creditSizes.clone();
        options.creditSizes.setCurrentIndex(value);

        this.setValueLabel(options.creditSizes.currentValue);

        this.onChange.dispatch(options);
    }
}
